import { Box } from '@mui/material';
import { Dispatch, MouseEvent, SetStateAction } from 'react';
import { initialAlertState, useAlertStatus } from '../../../../../../../customHook/useAlertStatus';
import { Role } from '../../../../../../../model/rolesAndPerms.model';
import { useAppSelector } from '../../../../../../../store/hooks';
import CustomAlert from '../../../../../../shared/CustomAlert/CustomAlert';
import { RoleSettings } from '../RoleSettings';
import { RoleCard } from './RoleCard';

type RolesGridProps = {
  roleCardElement: SVGSVGElement | null;
  handleOpenSettings: (event: MouseEvent<SVGSVGElement>, role: Role) => void;
  setRoleCardElement: Dispatch<SetStateAction<SVGSVGElement | null>>;
};

export const RolesGrid = ({
  roleCardElement,
  handleOpenSettings,
  setRoleCardElement,
}: RolesGridProps) => {
  const roles = useAppSelector((state) => state.rolesAndPermissions.roles);
  const { alertState, startOperation, completeOperation, setAlertState, getAlertContent } =
    useAlertStatus();

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1.5rem',
        marginTop: '24px',
      }}
    >
      {roles.map((role) => (
        <RoleCard role={role} handleOpenSettings={handleOpenSettings} />
      ))}
      <RoleSettings
        anchorElement={roleCardElement}
        onClose={() => setRoleCardElement(null)}
        startOperation={startOperation}
        completeOperation={completeOperation}
      />
      <CustomAlert
        open={alertState.status !== 'idle'}
        handleClose={() => setAlertState(initialAlertState)}
        message={getAlertContent(alertState)}
        error={alertState.status === 'error'}
      />
    </Box>
  );
};
